import React from 'react';
import PropTypes from 'prop-types';
import SweetAlert from 'react-bootstrap-sweetalert';
import { Button } from 'react-bootstrap';

const ENTITY = {
  org: 'سازمان',
  instructor: 'استاد',
};

export const titleGenerator = (entity, isUpdate = false) => `درخواست ${isUpdate ? 'ویرایش' : 'ساخت'} ${ENTITY[entity]}`;

export default function DarsupSweetAlert(props) {
  let { title, type, show, onConfirm, onCancel, children, ...otherProps } = props;

  return (
    <SweetAlert
      type={type}
      title={title}
      show={show}
      onConfirm={onConfirm}
      onCancel={onCancel}
      confirmBtnBsStyle={type}
      confirmBtnText={'تایید'}
      {...otherProps}
    >
      {children}
    </SweetAlert>
  );
}

DarsupSweetAlert.propTypes = {
  title: PropTypes.string,
  type: PropTypes.oneOf(['error', 'default', 'info', 'success', 'danger', 'warning', 'secondary']),
  show: PropTypes.bool.isRequired,
  onConfirm: PropTypes.func,
  onCancel: PropTypes.func,
};
